import "core-js/modules/es.array.slice";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";

/**
 * @author colynchen, elvenzhang
 */
import { warn } from './monitor';
import { isPlainObject } from '../util';
import env from './env';
var API_INVOKE = env.isMac ? 'callHandler' : env.isWin ? 'CallHandler' : 'invoke'; // 调用客户端的接口名称

var API_LISTENER = env.isMac ? 'registerHandler' : 'on'; // 监听客户端回调事件名

function _TenvideoJSBridge() {
  try {
    return window.TenvideoJSBridge || top.TenvideoJSBridge;
  } catch (e) {
    return null;
  }
} // 在 JS API 生效前，缓存调用函数


var cacheHandler = [];
document.addEventListener('onTenvideoJSBridgeReady', function () {
  console && console.log("[atom] TenvideoJSBridge is ready for ".concat(env.device));

  for (var i = 0, len = cacheHandler.length; i < len; i++) {
    cacheHandler[i]();
  }

  cacheHandler.length = 0;
}, false);
var isTenvideoJSBridgeError = false;
window.addEventListener('load', function () {
  var count = 0;
  var timer = setInterval(function () {
    if (_TenvideoJSBridge() && cacheHandler.length > 0) {
      clearInterval(timer);
      document.dispatchEvent(new Event('onTenvideoJSBridgeReady'));
    } else if (count > 10) {
      clearInterval(timer);
      isTenvideoJSBridgeError = true;
    }

    count++;
  }, 100);
});
setTimeout(function () {
  if (env.isApp && env.isWin && window.external) {
    window.TenvideoJSBridge = window.external;

    if (TenvideoJSBridge.AddObserver) {
      TenvideoJSBridge.AddObserver('*');
    }

    window.QQLive_OnObserve = function (event, res) {
      exec(event, res);
    };

    var onTenvideoJSBridgeReadyEvent = new Event('onTenvideoJSBridgeReady');
    document.dispatchEvent(onTenvideoJSBridgeReadyEvent);
  }
}, 10);
/**
 * JSBridge ready 回调
 * @returns {Promise}
 */

export function onTenvideoReady() {
  return new Promise(function (resolve) {
    if (!_TenvideoJSBridge()) {
      cacheHandler.push(resolve);
    } else {
      resolve();
    }
  });
}
export function invokeWin(api) {
  var _arguments = arguments;
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$ignoreAlarm = _ref.ignoreAlarm,
      ignoreAlarm = _ref$ignoreAlarm === void 0 ? false : _ref$ignoreAlarm,
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? 0 : _ref$timeout;

  console.log('invokeWin', api, params);
  return new Promise(function (resolve, reject) {
    var timer;

    if (timeout > 0) {
      timer = setTimeout(function () {
        // 防止接口调用超时
        reject({
          message: 'TenvideoJSBridge 找不到方法 "invoke"'
        });
      }, timeout);
    }

    onTenvideoReady().then(function () {
      timer && clearTimeout(timer);
      var args = Array.prototype.slice.call(_arguments);
      args.shift();

      if (TenvideoJSBridge[api]) {
        return resolve(TenvideoJSBridge[api].apply(null, args));
      } else {
        TenvideoJSBridge.CallHandler(api, JSON.stringify(params));
      }
    });
  });
}
/**
 * 调用客户端 api
 * @param {String} api
 * @param {Object} [params=null] 参数
 * @param {Boolean} [{ timeout = 0 }={}] timeout 调用超时时间
 * @returns {Promise}
 */

var BRIDGE_NOT_ALLOW = 50001;
var BRIDGE_INJECT_ERROR = 50002;
var BRIDGE_INVOKE_TIMEOUT = 50003;
var BRIDGE_INVOKE_FAIL = 50004;
export function invoke(api) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref2$timeout = _ref2.timeout,
      timeout = _ref2$timeout === void 0 ? 0 : _ref2$timeout;

  console.log("[atom] invoke api=".concat(api, " params="), params);
  return new Promise(function (resolve, reject) {
    if (!env.isApp) {
      return reject({
        message: '[atom] 非 APP 环境下，不支持调用 JSAPI',
        code: BRIDGE_NOT_ALLOW
      });
    }

    if (!_TenvideoJSBridge() && isTenvideoJSBridgeError) {
      return reject({
        message: '[atom] TenvideoJSBridge inject error',
        code: BRIDGE_INJECT_ERROR
      });
    }

    var timer;

    if (timeout > 0) {
      timer = setTimeout(function () {
        // 防止接口调用超时
        reject({
          message: "[atom] ".concat(api, " \u8C03\u7528\u8D85\u65F6\u65E0\u54CD\u5E94"),
          code: BRIDGE_INVOKE_TIMEOUT
        });
      }, timeout);
    }

    onTenvideoReady().then(function () {
      if (typeof _TenvideoJSBridge()[API_INVOKE] !== 'function') {
        return reject({
          message: 'TenvideoJSBridge 找不到方法 "invoke"',
          code: BRIDGE_INVOKE_FAIL
        });
      }

      var callback_result = _TenvideoJSBridge()[API_INVOKE](api, params, function (json_msg) {
        console.log("[atom] invoke callback api=".concat(api, " response="), json_msg);
        timer && clearTimeout(timer);

        if (!isPlainObject(json_msg)) {
          var res = null;

          try {
            res = JSON.parse(json_msg);
          } catch (e) {
            reject({
              errMsg: 'callback result ' + JSON.stringify(json_msg) + ' parse error "' + e.message + '", maybe is not supported!'
            });
          }

          if (!res) return resolve(json_msg);

          if (!isNaN(+res.errCode) && +res.errCode !== 0) {
            warn(res.errCode, res.errMsg);
            return reject(res);
          } else if (isPlainObject(res.result)) {
            return resolve(res.result);
          } else {
            return resolve(res);
          }
        } else {
          if (Object.keys(json_msg).length === 0) {
            console && console.warn && console.warn("[atom] api=".concat(api, " \u5728\u6B64\u7248\u672C\u6682\u672A\u652F\u6301\uFF0C\u8BF7\u5347\u7EA7\u5230\u6700\u65B0\u7248\u672C\uFF01"));
            return reject({
              errMsg: 'callback return "' + JSON.stringify(json_msg) + '", maybe is not supported!'
            });
          } else if (json_msg.result) {
            return resolve(json_msg.result);
          } else {
            return resolve(json_msg);
          }
        }
      });

      try {
        if (callback_result) {
          resolve(JSON.parse(callback_result));
          timer && clearTimeout(timer);
        }
      } finally {}
    });
  });
} // 缓存事件监听器

var _events = {};
export function on(event) {
  var listener = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var isOnce = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  console.log("[atom] listen event=".concat(event));

  if (typeof listener !== 'function') {
    throw new TypeError('[JSBridge] listener is not a function!');
  }

  if (!env.isWin && !_events[event]) {
    onTenvideoReady().then(function () {
      // debounce 方法
      // 避免客户端回调事件时执行多次 listener
      _TenvideoJSBridge()[API_LISTENER](event, exec.bind(null, event));
    });
  }

  if (!_events[event]) {
    _events[event] = [];
  }

  var listeners = _events[event];

  if (_indexOf(listeners, listener) === -1) {
    // 避免重复注册事件
    listeners.push({
      listener: listener,
      once: isOnce
    });
  }
}

if (env.isApp && env.isMac) {
  // Mac客户端增加全局消息通知事件处理
  on('onMessage', function (params) {
    if (params && params.event) {
      var data = params.data;

      try {
        data = JSON.parse(data);
      } catch (e) {}

      exec(params.event, data);
    }
  });
}
/**
 * 移除事件存储对象中的监听器
 * @author colynchen
 * @param event
 * @param callback
 */


export function off(event) {
  var listener = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var listeners = _events[event];

  if (!listeners || !listeners.length) {
    return;
  }

  var index = _indexOf(listeners, listener);

  if (index !== -1) {
    // 解除事件
    listeners.splice(index, 1);
  }
}
/**
 * 执行事件回调
 * @param {String} event      事件名称
 * @param {Object} jsonText   回调数据
 */

function exec(event, jsonText) {
  console.log("[atom] listen callback event=".concat(event), jsonText);
  var res = {};

  if (isPlainObject(jsonText)) {
    res = jsonText;
  } else {
    try {
      res = JSON.parse(jsonText);
    } catch (e) {
      if (!env.isApp && !env.isWin) {
        console.log(e);
      }
    }
  }

  var $events = _events[event];

  if ($events && $events.length > 0) {
    var len = $events.length;

    for (var i = 0; i < len; i++) {
      if ($events[i] && typeof $events[i].listener === 'function') {
        $events[i].listener(res);

        if ($events[i].once) {
          $events.splice(i, 1, null);
        }
      }
    }

    var tempEvents = [];

    for (var _i = 0; _i < len; _i++) {
      if ($events[_i]) {
        tempEvents.push($events[_i]);
      }
    }

    _events[event] = tempEvents;
  }
}
/**
 * 判断两个监听器是否一致
 * @param {Array} array 事件数组
 * @param {function} listener 监听器
 */


function _indexOf(array, listener) {
  var result = -1;

  for (var i = 0, len = array.length; i < len; i++) {
    // 由于直接对比 function 在同一场景下多次调用时，会导致两个 function 不相等的情况，故通过转字符串进行对比
    if (array[i].listener === listener) {
      result = i;
      break;
    }
  }

  return result;
}